import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { ACTION_PLAN_STATUS, ACTION_PLAN_STATUS_LABEL } from 'components/ActionPlans/constants';

const StatusLabel = styled.div`
  font-size: 14px;
  color: var(--text-primary);

  &.complete {
    color: var(--positive-green);
  }

  &.not-started {
    color: var(--text-secondary);
  }
`;

const OverdueLabel = styled.div`
  font-size: 12px;
  color: var(--inactive-orange);
`;

type Props = {
  status: number;
  overdueLabel?: string;
  dataTestId?: string;
};

const ActionPlansCompanyStatusCell = ({ status, overdueLabel, dataTestId }: Props) => (
  <div data-test-id={dataTestId}>
    <StatusLabel
      className={classNames({
        complete: status === ACTION_PLAN_STATUS.COMPLETE,
        'not-started': status === ACTION_PLAN_STATUS.NOT_STARTED,
      })}
      data-test-id={dataTestId ? `${dataTestId}-label` : undefined}
    >
      {ACTION_PLAN_STATUS_LABEL[status] ?? status}
    </StatusLabel>
    {overdueLabel && (
      <OverdueLabel data-test-id={dataTestId ? `${dataTestId}-overdue` : undefined}>{overdueLabel}</OverdueLabel>
    )}
  </div>
);

export default ActionPlansCompanyStatusCell;
